
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.18.0
 * Query Engine version: 4c784e32044a8a016d99474bd02a3b6123742169
 */
Prisma.prismaVersion = {
  client: "5.18.0",
  engine: "4c784e32044a8a016d99474bd02a3b6123742169"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.FeatureFlagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  scope: 'scope',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserAuthenticationTokenScalarFieldEnum = {
  id: 'id',
  email: 'email',
  token: 'token',
  valid: 'valid',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.QueueJobScalarFieldEnum = {
  id: 'id',
  name: 'name',
  status: 'status',
  singletonKey: 'singletonKey',
  externalJobId: 'externalJobId',
  output: 'output',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.QueueJobCacheScalarFieldEnum = {
  id: 'id',
  jobName: 'jobName',
  metadata: 'metadata',
  isBeingProcessed: 'isBeingProcessed',
  data: 'data',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.HrisSyncCampaignScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.HrisSyncScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  campaignId: 'campaignId',
  status: 'status',
  queueJobIds: 'queueJobIds',
  totalEmployeeCount: 'totalEmployeeCount',
  failedEmployeeNumbers: 'failedEmployeeNumbers',
  processedEmployeeCount: 'processedEmployeeCount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  invitedByUserId: 'invitedByUserId',
  permissionsId: 'permissionsId',
  flagsId: 'flagsId',
  companyId: 'companyId',
  invitationNeedsReview: 'invitationNeedsReview',
  canImpersonateDemoCompanies: 'canImpersonateDemoCompanies',
  canRequestSuperAdminRights: 'canRequestSuperAdminRights',
  status: 'status',
  locale: 'locale',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  provider: 'provider',
  providerId: 'providerId',
  profilePictureUrl: 'profilePictureUrl',
  isSuperAdmin: 'isSuperAdmin',
  onboardingRole: 'onboardingRole',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastActivityAt: 'lastActivityAt',
  blockedAt: 'blockedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.SuperAdminRightsLogScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  reason: 'reason',
  expiresAt: 'expiresAt',
  relinquishedAt: 'relinquishedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ExceptionalImpersonationLogScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  companyId: 'companyId',
  reason: 'reason',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserSessionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  hash: 'hash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyPermissionsScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  businessUnitsRestrictionMode: 'businessUnitsRestrictionMode',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserPermissionsScalarFieldEnum = {
  id: 'id',
  role: 'role',
  companyId: 'companyId',
  externalEmployeeId: 'externalEmployeeId',
  isManager: 'isManager',
  canAccessMarketData: 'canAccessMarketData',
  canSetupSSO: 'canSetupSSO',
  canAccessAdditionalFields: 'canAccessAdditionalFields',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  allowedLevels: 'allowedLevels'
};

exports.Prisma.UserPermissionsPolicyScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  employeeSalaryBandAccessLevel: 'employeeSalaryBandAccessLevel',
  employeeSalaryBandCanAccessMarketData: 'employeeSalaryBandCanAccessMarketData',
  managerSalaryBandAccessLevel: 'managerSalaryBandAccessLevel',
  managerSalaryBandCanAccessMarketData: 'managerSalaryBandCanAccessMarketData'
};

exports.Prisma.UserFlagsScalarFieldEnum = {
  id: 'id',
  collapseMarketDataFilters: 'collapseMarketDataFilters',
  hasSeenCompaniesFilter: 'hasSeenCompaniesFilter',
  hasSeenHrmsPrompt: 'hasSeenHrmsPrompt',
  hasSeenDashboardCompanySwitch: 'hasSeenDashboardCompanySwitch',
  hasSeenOfferDragHandle: 'hasSeenOfferDragHandle',
  showDashboardCompensationIntro: 'showDashboardCompensationIntro',
  showDashboardGenderEqualityIntro: 'showDashboardGenderEqualityIntro',
  showSalaryBandsMarket: 'showSalaryBandsMarket',
  showSalaryBandsEmptyLevels: 'showSalaryBandsEmptyLevels',
  compensationPlanningEligibleEmployeeSort: 'compensationPlanningEligibleEmployeeSort',
  marketDataPeopleDashboardColumns: 'marketDataPeopleDashboardColumns',
  salaryBandsPeopleDashboardColumns: 'salaryBandsPeopleDashboardColumns',
  salaryRangeEmployeesColumns: 'salaryRangeEmployeesColumns',
  externalEmployeesColumns: 'externalEmployeesColumns',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobRequestScalarFieldEnum = {
  id: 'id',
  name: 'name',
  userId: 'userId',
  externalJobId: 'externalJobId',
  description: 'description',
  comment: 'comment',
  companyId: 'companyId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobFamilyScalarFieldEnum = {
  id: 'id',
  name: 'name',
  category: 'category',
  translations: 'translations',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobScalarFieldEnum = {
  id: 'id',
  familyId: 'familyId',
  name: 'name',
  translations: 'translations',
  description: 'description',
  descriptionTranslations: 'descriptionTranslations',
  availableLevels: 'availableLevels',
  salaryBandTemplate: 'salaryBandTemplate',
  salaryBandAdvancedTemplate: 'salaryBandAdvancedTemplate',
  salaryBandTemplateTranslations: 'salaryBandTemplateTranslations',
  salaryBandAdvancedTemplateTranslations: 'salaryBandAdvancedTemplateTranslations',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.JobAliasScalarFieldEnum = {
  id: 'id',
  name: 'name',
  jobId: 'jobId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  locale: 'locale',
  isRootAlias: 'isRootAlias'
};

exports.Prisma.JobAliasEmbeddingScalarFieldEnum = {
  id: 'id',
  jobAliasId: 'jobAliasId',
  embedding: 'embedding',
  embeddingModel: 'embeddingModel',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CustomJobScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  userId: 'userId',
  name: 'name',
  description: 'description',
  sharedWithCompany: 'sharedWithCompany',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CustomJobItemScalarFieldEnum = {
  id: 'id',
  customJobId: 'customJobId',
  jobId: 'jobId',
  weight: 'weight',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CurrencyScalarFieldEnum = {
  id: 'id',
  code: 'code',
  symbol: 'symbol',
  name: 'name',
  translations: 'translations',
  euroExchangeRate: 'euroExchangeRate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CountryScalarFieldEnum = {
  id: 'id',
  defaultCurrencyId: 'defaultCurrencyId',
  alpha2: 'alpha2',
  alpha3: 'alpha3',
  name: 'name',
  translations: 'translations',
  employmentCostRate: 'employmentCostRate',
  legalMinimumWage: 'legalMinimumWage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdditionalMonthRuleScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  countryId: 'countryId',
  month: 'month',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CountryStatsScalarFieldEnum = {
  id: 'id',
  countryId: 'countryId',
  period: 'period',
  monthlyInflationRate: 'monthlyInflationRate',
  yearlyInflationRate: 'yearlyInflationRate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CountryAliasScalarFieldEnum = {
  id: 'id',
  alias: 'alias',
  countryId: 'countryId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MarketPositioningScalarFieldEnum = {
  id: 'id',
  industryId: 'industryId',
  minHeadcount: 'minHeadcount',
  maxHeadcount: 'maxHeadcount',
  headcount: 'headcount',
  fundingRounds: 'fundingRounds',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmailNotificationsScalarFieldEnum = {
  id: 'id',
  marketMovementNotifications: 'marketMovementNotifications',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyScalarFieldEnum = {
  id: 'id',
  companyBenchmarkRestrictionId: 'companyBenchmarkRestrictionId',
  liveSurveyId: 'liveSurveyId',
  statsId: 'statsId',
  logoId: 'logoId',
  coverId: 'coverId',
  compareSpecificLocationId: 'compareSpecificLocationId',
  emailNotificationsId: 'emailNotificationsId',
  marketPositioningId: 'marketPositioningId',
  defaultCountryId: 'defaultCountryId',
  defaultSalaryGridId: 'defaultSalaryGridId',
  samlConfigurationId: 'samlConfigurationId',
  comparisonGeographicStrategy: 'comparisonGeographicStrategy',
  type: 'type',
  demo: 'demo',
  excludedFromDataset: 'excludedFromDataset',
  hasImportedEmployees: 'hasImportedEmployees',
  hasFinishedMapping: 'hasFinishedMapping',
  name: 'name',
  url: 'url',
  wttjUrl: 'wttjUrl',
  emailDomains: 'emailDomains',
  linkedInUrl: 'linkedInUrl',
  linkedInIndustry: 'linkedInIndustry',
  visible: 'visible',
  highestAvailableLevel: 'highestAvailableLevel',
  highestAvailableLevelSource: 'highestAvailableLevelSource',
  useAdvancedLevels: 'useAdvancedLevels',
  useExternalLevels: 'useExternalLevels',
  useExternalLevelsSource: 'useExternalLevelsSource',
  enableGoogleDriveShare: 'enableGoogleDriveShare',
  initialHubspotDealId: 'initialHubspotDealId',
  hubspotCompanyId: 'hubspotCompanyId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  disabledAt: 'disabledAt',
  lastSpreadsheetImportedAt: 'lastSpreadsheetImportedAt',
  onboardingStep: 'onboardingStep',
  globalTargetPercentile: 'globalTargetPercentile',
  percentileRangeWidth: 'percentileRangeWidth'
};

exports.Prisma.CompanyFileScalarFieldEnum = {
  id: 'id',
  ownerUserId: 'ownerUserId',
  companyId: 'companyId',
  name: 'name',
  path: 'path',
  bucket: 'bucket',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyBenchmarkRestrictionScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  allowedLevels: 'allowedLevels'
};

exports.Prisma.GoogleSheetScalarFieldEnum = {
  id: 'id',
  fileId: 'fileId',
  companyId: 'companyId',
  fileName: 'fileName',
  type: 'type'
};

exports.Prisma.CompanySamlConfigurationScalarFieldEnum = {
  id: 'id',
  entryPoint: 'entryPoint',
  issuer: 'issuer',
  certificate: 'certificate',
  enforceSamlAuthentication: 'enforceSamlAuthentication',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  configuration: 'configuration',
  nameIdPath: 'nameIdPath',
  firstNamePath: 'firstNamePath',
  lastNamePath: 'lastNamePath'
};

exports.Prisma.CompanyImpersonationAccessScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  requestedAt: 'requestedAt',
  declinedAt: 'declinedAt'
};

exports.Prisma.CompanyImpersonationLogScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  impersonationWhitelistId: 'impersonationWhitelistId',
  action: 'action',
  message: 'message',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyTargetPercentileScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  jobFamilyId: 'jobFamilyId',
  value: 'value',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyTagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  translations: 'translations',
  description: 'description',
  descriptionTranslations: 'descriptionTranslations',
  category: 'category',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanySurveyScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  currencyId: 'currencyId',
  capTableManagementTool: 'capTableManagementTool',
  status: 'status',
  employeesCount: 'employeesCount',
  hrms: 'hrms',
  growthRate: 'growthRate',
  totalFunding: 'totalFunding',
  lastFundingRound: 'lastFundingRound',
  involuntaryTurnoverRate: 'involuntaryTurnoverRate',
  voluntaryTurnoverRate: 'voluntaryTurnoverRate',
  valuation: 'valuation',
  employeesEquityPoolSize: 'employeesEquityPoolSize',
  salaryIncreaseBudget: 'salaryIncreaseBudget',
  salaryIncreaseFrequency: 'salaryIncreaseFrequency',
  salaryIncreaseEligibility: 'salaryIncreaseEligibility',
  shareCliffDurationInMonths: 'shareCliffDurationInMonths',
  shareExerciseWindowDuration: 'shareExerciseWindowDuration',
  shareGrantAmount: 'shareGrantAmount',
  shareGrantPolicyDetails: 'shareGrantPolicyDetails',
  shareGrantPolicy: 'shareGrantPolicy',
  shareMarketValue: 'shareMarketValue',
  shareSecondarySalesConditions: 'shareSecondarySalesConditions',
  shareStrikePrice: 'shareStrikePrice',
  shareTypes: 'shareTypes',
  customShareType: 'customShareType',
  customStockOptionType: 'customStockOptionType',
  shareVestingDuration: 'shareVestingDuration',
  hasShareAccelerationClause: 'hasShareAccelerationClause',
  hasShareCliff: 'hasShareCliff',
  hasShareGrantPolicy: 'hasShareGrantPolicy',
  hasShareLeaveClause: 'hasShareLeaveClause',
  hasTransparentCompensationPolicy: 'hasTransparentCompensationPolicy',
  hasTransparentSalaryGrid: 'hasTransparentSalaryGrid',
  hasTransparentIndividualSalaries: 'hasTransparentIndividualSalaries',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  collectedAt: 'collectedAt'
};

exports.Prisma.CompanyEmploymentCostScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  countryId: 'countryId',
  costRate: 'costRate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyStatsScalarFieldEnum = {
  id: 'id',
  genderCompletionRate: 'genderCompletionRate',
  totalPayroll: 'totalPayroll',
  compensationMeanDifferenceFromTarget: 'compensationMeanDifferenceFromTarget',
  generalAndAdministrativeCompensationMeanDifferenceFromTarget: 'generalAndAdministrativeCompensationMeanDifferenceFromTarget',
  techCompensationMeanDifferenceFromTarget: 'techCompensationMeanDifferenceFromTarget',
  salesAndMarketingMeanDifferenceFromTarget: 'salesAndMarketingMeanDifferenceFromTarget',
  payGapScore: 'payGapScore',
  topEarnersScore: 'topEarnersScore',
  managementScore: 'managementScore',
  marketFairnessScore: 'marketFairnessScore',
  genderEqualityIndex: 'genderEqualityIndex',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MarketFiltersScalarFieldEnum = {
  id: 'id',
  industryId: 'industryId',
  minEmployeesCount: 'minEmployeesCount',
  maxEmployeesCount: 'maxEmployeesCount',
  headcount: 'headcount',
  fundingRounds: 'fundingRounds',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmployeeLocationScalarFieldEnum = {
  id: 'id',
  fallbackLocationId: 'fallbackLocationId',
  countryId: 'countryId',
  statsId: 'statsId',
  name: 'name',
  translations: 'translations',
  isCountryCapital: 'isCountryCapital',
  isRemote: 'isRemote',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmployeeLocationStatsScalarFieldEnum = {
  id: 'id',
  numbeoIndex: 'numbeoIndex',
  figuresIncumbentsCount: 'figuresIncumbentsCount',
  figuresIndex: 'figuresIndex',
  glassdoorIncumbentsCount: 'glassdoorIncumbentsCount',
  glassdoorIndex: 'glassdoorIndex',
  eriIndex: 'eriIndex',
  gitLabIndex: 'gitLabIndex',
  postHogIndex: 'postHogIndex',
  employmentCostRate: 'employmentCostRate',
  oysterUrl: 'oysterUrl',
  nomadListUrl: 'nomadListUrl',
  youTubeSongUrl: 'youTubeSongUrl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmployeeLocationAliasScalarFieldEnum = {
  id: 'id',
  alias: 'alias',
  employeeLocationId: 'employeeLocationId',
  countryId: 'countryId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BenchmarkLevelScalarFieldEnum = {
  id: 'id',
  name: 'name',
  translations: 'translations',
  descriptions: 'descriptions',
  userPermissionsId: 'userPermissionsId',
  frameworkId: 'frameworkId',
  min: 'min',
  max: 'max',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.LevelFrameworkScalarFieldEnum = {
  id: 'id',
  name: 'name',
  isPublic: 'isPublic'
};

exports.Prisma.EmployeeStatsScalarFieldEnum = {
  id: 'id',
  comparedLevels: 'comparedLevels',
  comparedLocationId: 'comparedLocationId',
  comparedCountryId: 'comparedCountryId',
  employeeId: 'employeeId',
  comparisonScope: 'comparisonScope',
  status: 'status',
  comparedEmployeesCount: 'comparedEmployeesCount',
  comparedCompaniesCount: 'comparedCompaniesCount',
  targetPercentile: 'targetPercentile',
  totalCash: 'totalCash',
  onTargetEarnings: 'onTargetEarnings',
  totalCashForPercentile: 'totalCashForPercentile',
  totalCashDifference: 'totalCashDifference',
  totalCashPercentageDifference: 'totalCashPercentageDifference',
  totalCashMarketPositioning: 'totalCashMarketPositioning',
  totalCashDataQuality: 'totalCashDataQuality',
  baseSalaryForPercentile: 'baseSalaryForPercentile',
  baseSalaryDifference: 'baseSalaryDifference',
  baseSalaryPercentageDifference: 'baseSalaryPercentageDifference',
  baseSalaryMarketPositioning: 'baseSalaryMarketPositioning',
  baseSalaryDataQuality: 'baseSalaryDataQuality',
  onTargetEarningsForPercentile: 'onTargetEarningsForPercentile',
  onTargetEarningsDifference: 'onTargetEarningsDifference',
  onTargetEarningsPercentageDifference: 'onTargetEarningsPercentageDifference',
  onTargetEarningsMarketPositioning: 'onTargetEarningsMarketPositioning',
  onTargetEarningsDataQuality: 'onTargetEarningsDataQuality',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EmployeeScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  companyId: 'companyId',
  surveyId: 'surveyId',
  jobId: 'jobId',
  locationId: 'locationId',
  mappingLocationId: 'mappingLocationId',
  currencyId: 'currencyId',
  benchmarkLevelId: 'benchmarkLevelId',
  pictureId: 'pictureId',
  liveEmployeeStatsId: 'liveEmployeeStatsId',
  status: 'status',
  source: 'source',
  level: 'level',
  bucketHash: 'bucketHash',
  firstName: 'firstName',
  lastName: 'lastName',
  baseSalary: 'baseSalary',
  onTargetBonus: 'onTargetBonus',
  onTargetBonusPercentage: 'onTargetBonusPercentage',
  fixedBonus: 'fixedBonus',
  fixedBonusPercentage: 'fixedBonusPercentage',
  gender: 'gender',
  isFounder: 'isFounder',
  employeeNumber: 'employeeNumber',
  externalId: 'externalId',
  externalJobTitle: 'externalJobTitle',
  externalLevel: 'externalLevel',
  hireDate: 'hireDate',
  birthDate: 'birthDate',
  updateStrategy: 'updateStrategy',
  updateReason: 'updateReason',
  liveAt: 'liveAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.DatasetEmployeeScalarFieldEnum = {
  id: 'id',
  jobId: 'jobId',
  locationId: 'locationId',
  companyId: 'companyId',
  baseSalary: 'baseSalary',
  currencyCode: 'currencyCode',
  euroExchangeRate: 'euroExchangeRate',
  excludedFromDataset: 'excludedFromDataset',
  companyTagsIds: 'companyTagsIds',
  companyHeadcount: 'companyHeadcount',
  churnedCompanyId: 'churnedCompanyId',
  onTargetBonus: 'onTargetBonus',
  fixedBonus: 'fixedBonus',
  externalId: 'externalId',
  gender: 'gender',
  companyFundingRound: 'companyFundingRound',
  level: 'level',
  liveAt: 'liveAt',
  lastValidAt: 'lastValidAt',
  deadAt: 'deadAt'
};

exports.Prisma.EmployeeDataValidationFlagScalarFieldEnum = {
  id: 'id',
  employeeId: 'employeeId',
  datasetEmployeeId: 'datasetEmployeeId',
  companyId: 'companyId',
  authorId: 'authorId',
  closedById: 'closedById',
  comment: 'comment',
  isLive: 'isLive',
  ignore: 'ignore',
  origin: 'origin',
  type: 'type',
  closedAt: 'closedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompanyDataValidationFlagScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  comment: 'comment',
  isLive: 'isLive',
  type: 'type',
  closedAt: 'closedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ImageScalarFieldEnum = {
  id: 'id',
  bucket: 'bucket',
  path: 'path',
  mimeType: 'mimeType',
  width: 'width',
  height: 'height',
  size: 'size',
  originalName: 'originalName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ContactScalarFieldEnum = {
  id: 'id',
  source: 'source',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  company: 'company',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.IntegrationSettingsScalarFieldEnum = {
  id: 'id',
  source: 'source',
  companyId: 'companyId',
  integrationLockId: 'integrationLockId',
  domain: 'domain',
  clientId: 'clientId',
  clientSecret: 'clientSecret',
  fteCustomFieldName: 'fteCustomFieldName',
  levelCustomFieldName: 'levelCustomFieldName',
  externalIdCustomFieldName: 'externalIdCustomFieldName',
  baseSalaryCustomFieldName: 'baseSalaryCustomFieldName',
  baseSalaryCustomFieldFrequency: 'baseSalaryCustomFieldFrequency',
  variableCustomFieldName: 'variableCustomFieldName',
  variableCustomFieldFrequency: 'variableCustomFieldFrequency',
  businessUnitCustomFieldName: 'businessUnitCustomFieldName',
  locationCustomFieldName: 'locationCustomFieldName',
  jobCustomFieldName: 'jobCustomFieldName',
  isHolidayAllowanceIncludedInBaseSalary: 'isHolidayAllowanceIncludedInBaseSalary',
  applyFlatHolidayAllowance: 'applyFlatHolidayAllowance',
  holidayAllowanceCustomFieldName: 'holidayAllowanceCustomFieldName',
  holidayAllowanceCustomFieldFrequency: 'holidayAllowanceCustomFieldFrequency',
  isCustomFieldOnlyHolidayAllowance: 'isCustomFieldOnlyHolidayAllowance',
  remunerationBlacklist: 'remunerationBlacklist',
  anonymous: 'anonymous',
  enabled: 'enabled',
  retryCount: 'retryCount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastSynchronisedAt: 'lastSynchronisedAt',
  lastSyncCreated: 'lastSyncCreated',
  lastSyncUpdated: 'lastSyncUpdated',
  lastSyncDeleted: 'lastSyncDeleted'
};

exports.Prisma.IntegrationLockScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  integrationSettingsId: 'integrationSettingsId',
  onTargetBonus: 'onTargetBonus',
  fteDivider: 'fteDivider',
  fixedBonus: 'fixedBonus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdditionalFieldScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  name: 'name',
  nature: 'nature',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdditionalFieldMappingScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  additionalFieldId: 'additionalFieldId',
  integrationSettingsId: 'integrationSettingsId',
  hrisFieldName: 'hrisFieldName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AdditionalFieldValueScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  additionalFieldId: 'additionalFieldId',
  additionalFieldMappingId: 'additionalFieldMappingId',
  externalEmployeeId: 'externalEmployeeId',
  stringValue: 'stringValue',
  numberValue: 'numberValue',
  dateValue: 'dateValue',
  percentageValue: 'percentageValue',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AnalyticsEmployeeScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  externalEmployeeId: 'externalEmployeeId',
  totalCash: 'totalCash',
  onTargetEarnings: 'onTargetEarnings',
  baseSalary: 'baseSalary',
  gender: 'gender',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ExternalEmployeeScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  currencyId: 'currencyId',
  pictureId: 'pictureId',
  locationId: 'locationId',
  jobId: 'jobId',
  levelId: 'levelId',
  managerExternalEmployeeId: 'managerExternalEmployeeId',
  mappedEmployeeId: 'mappedEmployeeId',
  performanceReviewRatingId: 'performanceReviewRatingId',
  liveSalaryRangeEmployeeId: 'liveSalaryRangeEmployeeId',
  source: 'source',
  status: 'status',
  mappingSkipReason: 'mappingSkipReason',
  driftFields: 'driftFields',
  externalId: 'externalId',
  firstName: 'firstName',
  lastName: 'lastName',
  employeeNumber: 'employeeNumber',
  normalisedColumns: 'normalisedColumns',
  gender: 'gender',
  email: 'email',
  hireDate: 'hireDate',
  birthDate: 'birthDate',
  isFounder: 'isFounder',
  locationComplement: 'locationComplement',
  comments: 'comments',
  fteDivider: 'fteDivider',
  businessUnit: 'businessUnit',
  extraBusinessUnits: 'extraBusinessUnits',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.ExternalLocationScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  countryId: 'countryId',
  mappedLocationId: 'mappedLocationId',
  suggestedLocationId: 'suggestedLocationId',
  suggestionConfidenceScore: 'suggestionConfidenceScore',
  externalId: 'externalId',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  suggestedAt: 'suggestedAt',
  suggestionSkippedAt: 'suggestionSkippedAt',
  skippedAt: 'skippedAt',
  autoMappingEnabled: 'autoMappingEnabled'
};

exports.Prisma.ExternalJobScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  mappedJobId: 'mappedJobId',
  suggestedJobId: 'suggestedJobId',
  externalId: 'externalId',
  name: 'name',
  suggestionConfidenceScore: 'suggestionConfidenceScore',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  suggestedAt: 'suggestedAt',
  skippedAt: 'skippedAt',
  suggestionSkippedAt: 'suggestionSkippedAt',
  autoMappedAt: 'autoMappedAt'
};

exports.Prisma.ExternalJobMappingSuggestionScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  externalJobId: 'externalJobId',
  suggestedJobId: 'suggestedJobId',
  similarityScore: 'similarityScore',
  embeddingModel: 'embeddingModel',
  suggestedAt: 'suggestedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ExternalLevelScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  mappedBenchmarkLevelId: 'mappedBenchmarkLevelId',
  externalId: 'externalId',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  skippedAt: 'skippedAt',
  mappedLevel: 'mappedLevel'
};

exports.Prisma.ExternalRemunerationItemScalarFieldEnum = {
  id: 'id',
  employeeId: 'employeeId',
  natureId: 'natureId',
  source: 'source',
  externalId: 'externalId',
  amount: 'amount',
  asPercentage: 'asPercentage',
  numberMonths: 'numberMonths',
  status: 'status',
  date: 'date',
  endsAt: 'endsAt',
  reason: 'reason',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ExternalRemunerationNatureScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  source: 'source',
  mappedType: 'mappedType',
  mappedSubType: 'mappedSubType',
  name: 'name',
  externalId: 'externalId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CustomRemunerationItemScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  integrationSettingsId: 'integrationSettingsId',
  hrisFieldName: 'hrisFieldName',
  name: 'name',
  frequency: 'frequency',
  type: 'type',
  subtype: 'subtype',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MarketDataSearchScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  marketFiltersId: 'marketFiltersId',
  comparedMarketFiltersId: 'comparedMarketFiltersId',
  hash: 'hash',
  source: 'source',
  input: 'input',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FiltersPresetScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  name: 'name',
  companyId: 'companyId',
  marketFiltersId: 'marketFiltersId',
  input: 'input',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.GlassdoorCompensationDataScalarFieldEnum = {
  id: 'id',
  currencyId: 'currencyId',
  jobId: 'jobId',
  locationId: 'locationId',
  averageBaseSalary: 'averageBaseSalary',
  employeesCount: 'employeesCount',
  confidence: 'confidence',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompensationPlanningCampaignScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  currencyId: 'currencyId',
  name: 'name',
  enableInflationBudget: 'enableInflationBudget',
  enableMarketAdjustmentBudget: 'enableMarketAdjustmentBudget',
  enableSalaryBandsAdjustmentBudget: 'enableSalaryBandsAdjustmentBudget',
  enableGeneralMeritIncreaseBudget: 'enableGeneralMeritIncreaseBudget',
  enablePerformanceBasedIncreaseBudget: 'enablePerformanceBasedIncreaseBudget',
  targetBudget: 'targetBudget',
  salaryReviewMode: 'salaryReviewMode',
  performanceRewardFactor: 'performanceRewardFactor',
  marketAdjustmentFactor: 'marketAdjustmentFactor',
  salaryBandsAdjustmentFactor: 'salaryBandsAdjustmentFactor',
  maxDistanceToTarget: 'maxDistanceToTarget',
  meritIncreaseBudget: 'meritIncreaseBudget',
  eligibilityHireDate: 'eligibilityHireDate',
  eligibilityJobFamilyNames: 'eligibilityJobFamilyNames',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompensationPlanningInflationSettingsScalarFieldEnum = {
  id: 'id',
  campaignId: 'campaignId',
  countryId: 'countryId',
  inflationRate: 'inflationRate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompensationPlanningEmployeeScalarFieldEnum = {
  id: 'id',
  campaignId: 'campaignId',
  externalEmployeeId: 'externalEmployeeId',
  performanceRatingId: 'performanceRatingId',
  isEligible: 'isEligible',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompensationPlanningPerformanceRatingScalarFieldEnum = {
  id: 'id',
  campaignId: 'campaignId',
  name: 'name',
  position: 'position',
  tier1SalaryIncreasePercentage: 'tier1SalaryIncreasePercentage',
  tier2SalaryIncreasePercentage: 'tier2SalaryIncreasePercentage',
  tier3SalaryIncreasePercentage: 'tier3SalaryIncreasePercentage',
  tier4SalaryIncreasePercentage: 'tier4SalaryIncreasePercentage',
  tier5SalaryIncreasePercentage: 'tier5SalaryIncreasePercentage',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PerformanceReviewCycleScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  scope: 'scope',
  selectedCycleIds: 'selectedCycleIds',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PerformanceReviewRatingScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  performanceReviewCycleId: 'performanceReviewCycleId',
  position: 'position',
  name: 'name',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PerformanceReviewIntegrationSettingsScalarFieldEnum = {
  id: 'id',
  enabled: 'enabled',
  source: 'source',
  companyId: 'companyId',
  clientId: 'clientId',
  clientSecret: 'clientSecret',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastSynchronisedAt: 'lastSynchronisedAt'
};

exports.Prisma.SalaryGridConfigurationChangeScalarFieldEnum = {
  id: 'id',
  gridId: 'gridId',
  bandId: 'bandId',
  rangeId: 'rangeId',
  userId: 'userId',
  actionId: 'actionId',
  label: 'label',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  reason: 'reason',
  initialState: 'initialState',
  newState: 'newState'
};

exports.Prisma.SalaryGridScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  width: 'width',
  configurationStep: 'configurationStep',
  measure: 'measure',
  tiersMode: 'tiersMode',
  tiersNames: 'tiersNames',
  disableWarnings: 'disableWarnings',
  status: 'status',
  name: 'name',
  liveAt: 'liveAt',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalaryBandJobScalarFieldEnum = {
  id: 'id',
  gridId: 'gridId',
  name: 'name',
  description: 'description',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalaryBandMappedJobScalarFieldEnum = {
  id: 'id',
  gridId: 'gridId',
  salaryBandJobId: 'salaryBandJobId',
  externalJobId: 'externalJobId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalaryBandLevelScalarFieldEnum = {
  id: 'id',
  gridId: 'gridId',
  name: 'name',
  description: 'description',
  track: 'track',
  position: 'position',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalaryBandMappedLevelScalarFieldEnum = {
  id: 'id',
  gridId: 'gridId',
  salaryBandLevelId: 'salaryBandLevelId',
  externalLevelId: 'externalLevelId',
  level: 'level',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalaryBandBenchmarkedLevelScalarFieldEnum = {
  id: 'id',
  gridId: 'gridId',
  salaryBandLevelId: 'salaryBandLevelId',
  level: 'level',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalaryBandLocationScalarFieldEnum = {
  id: 'id',
  gridId: 'gridId',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalaryBandMappedLocationScalarFieldEnum = {
  id: 'id',
  gridId: 'gridId',
  salaryBandLocationId: 'salaryBandLocationId',
  externalLocationId: 'externalLocationId',
  locationId: 'locationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalaryBandScalarFieldEnum = {
  id: 'id',
  gridId: 'gridId',
  jobId: 'jobId',
  locationId: 'locationId',
  currencyId: 'currencyId',
  marketPositioningId: 'marketPositioningId',
  isDraft: 'isDraft',
  measure: 'measure',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalaryBandBenchmarkedJobScalarFieldEnum = {
  id: 'id',
  gridId: 'gridId',
  bandId: 'bandId',
  jobId: 'jobId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalaryBandBenchmarkedLocationScalarFieldEnum = {
  id: 'id',
  gridId: 'gridId',
  bandId: 'bandId',
  locationId: 'locationId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalaryBandMarketPositioningScalarFieldEnum = {
  id: 'id',
  industryId: 'industryId',
  minHeadcount: 'minHeadcount',
  maxHeadcount: 'maxHeadcount',
  headcount: 'headcount',
  fundingRounds: 'fundingRounds',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalaryRangeScalarFieldEnum = {
  id: 'id',
  bandId: 'bandId',
  levelId: 'levelId',
  midpoint: 'midpoint',
  inferredPercentileRank: 'inferredPercentileRank',
  targetPercentileRank: 'targetPercentileRank',
  min: 'min',
  max: 'max',
  baseSalaryP10: 'baseSalaryP10',
  baseSalaryP25: 'baseSalaryP25',
  baseSalaryP50: 'baseSalaryP50',
  baseSalaryP75: 'baseSalaryP75',
  baseSalaryP90: 'baseSalaryP90',
  baseSalaryDataQuality: 'baseSalaryDataQuality',
  onTargetEarningsP10: 'onTargetEarningsP10',
  onTargetEarningsP25: 'onTargetEarningsP25',
  onTargetEarningsP50: 'onTargetEarningsP50',
  onTargetEarningsP75: 'onTargetEarningsP75',
  onTargetEarningsP90: 'onTargetEarningsP90',
  onTargetEarningsDataQuality: 'onTargetEarningsDataQuality',
  createdWithoutMarketData: 'createdWithoutMarketData',
  distinctCompaniesCount: 'distinctCompaniesCount',
  employeesCount: 'employeesCount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalaryRangeEmployeeScalarFieldEnum = {
  id: 'id',
  gridId: 'gridId',
  externalEmployeeId: 'externalEmployeeId',
  rangeId: 'rangeId',
  baseSalaryCompaRatio: 'baseSalaryCompaRatio',
  baseSalaryRangePenetration: 'baseSalaryRangePenetration',
  baseSalaryRangePositioning: 'baseSalaryRangePositioning',
  onTargetEarningsCompaRatio: 'onTargetEarningsCompaRatio',
  onTargetEarningsRangePenetration: 'onTargetEarningsRangePenetration',
  onTargetEarningsRangePositioning: 'onTargetEarningsRangePositioning',
  orderingCompaRatio: 'orderingCompaRatio',
  orderingRangePenetration: 'orderingRangePenetration',
  overridden: 'overridden',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SalaryBandShareScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  bandId: 'bandId',
  permissionsId: 'permissionsId',
  canAccessSalaryBandBenchmarkData: 'canAccessSalaryBandBenchmarkData',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ExternalBenchmarkScalarFieldEnum = {
  id: 'id',
  gridId: 'gridId',
  name: 'name',
  colorHex: 'colorHex',
  importedAt: 'importedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ExternalBenchmarkLevelScalarFieldEnum = {
  id: 'id',
  gridId: 'gridId',
  benchmarkId: 'benchmarkId',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ExternalBenchmarkGroupScalarFieldEnum = {
  id: 'id',
  gridId: 'gridId',
  benchmarkId: 'benchmarkId',
  locationName: 'locationName',
  jobName: 'jobName',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ExternalBenchmarkEntryScalarFieldEnum = {
  id: 'id',
  gridId: 'gridId',
  benchmarkId: 'benchmarkId',
  groupId: 'groupId',
  levelId: 'levelId',
  currencyId: 'currencyId',
  externalId: 'externalId',
  baseSalaryP10: 'baseSalaryP10',
  baseSalaryP25: 'baseSalaryP25',
  baseSalaryP50: 'baseSalaryP50',
  baseSalaryP75: 'baseSalaryP75',
  baseSalaryP90: 'baseSalaryP90',
  onTargetEarningsP10: 'onTargetEarningsP10',
  onTargetEarningsP25: 'onTargetEarningsP25',
  onTargetEarningsP50: 'onTargetEarningsP50',
  onTargetEarningsP75: 'onTargetEarningsP75',
  onTargetEarningsP90: 'onTargetEarningsP90',
  employeesCount: 'employeesCount',
  distinctCompaniesCount: 'distinctCompaniesCount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompensationReviewCampaignScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  currencyId: 'currencyId',
  budgetId: 'budgetId',
  promotionBudgetId: 'promotionBudgetId',
  finalReviewerId: 'finalReviewerId',
  allowReviewersRecommendationOverride: 'allowReviewersRecommendationOverride',
  performanceReviewCycleId: 'performanceReviewCycleId',
  name: 'name',
  status: 'status',
  configurationStep: 'configurationStep',
  validatedConfigurationSteps: 'validatedConfigurationSteps',
  requiresSandboxReset: 'requiresSandboxReset',
  startDate: 'startDate',
  endDate: 'endDate',
  variablePayReviewEnabled: 'variablePayReviewEnabled',
  relativeVariablePayEnabled: 'relativeVariablePayEnabled',
  annualPerformanceBonusReviewEnabled: 'annualPerformanceBonusReviewEnabled',
  reviewerAnnualPerformanceBonusReviewEnabled: 'reviewerAnnualPerformanceBonusReviewEnabled',
  exceptionalBonusReviewEnabled: 'exceptionalBonusReviewEnabled',
  preferedSalaryDisplay: 'preferedSalaryDisplay',
  maxReviewersCount: 'maxReviewersCount',
  launchNotificationEnabled: 'launchNotificationEnabled',
  launchNotificationContent: 'launchNotificationContent',
  reminderNotificationEnabled: 'reminderNotificationEnabled',
  reviewerGuidelines: 'reviewerGuidelines',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompensationReviewCurrencyScalarFieldEnum = {
  id: 'id',
  campaignId: 'campaignId',
  offCycleReviewConfigurationId: 'offCycleReviewConfigurationId',
  companyId: 'companyId',
  currencyId: 'currencyId',
  isReferenceCurrency: 'isReferenceCurrency',
  euroExchangeRate: 'euroExchangeRate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompensationReviewBudgetScalarFieldEnum = {
  id: 'id',
  budgetingMethod: 'budgetingMethod',
  amount: 'amount',
  definitionMethod: 'definitionMethod',
  distributionKey: 'distributionKey',
  adjustmentCriteria: 'adjustmentCriteria',
  recommendationsAllocation: 'recommendationsAllocation',
  postSmoothingBudgetDifference: 'postSmoothingBudgetDifference',
  postSmoothingOverriddenEmployeesCount: 'postSmoothingOverriddenEmployeesCount',
  performanceRewardFactor: 'performanceRewardFactor',
  adjustmentFactor: 'adjustmentFactor',
  skippedPerformanceRatingIds: 'skippedPerformanceRatingIds',
  skippedPositionings: 'skippedPositionings',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompensationReviewSubBudgetScalarFieldEnum = {
  id: 'id',
  campaignId: 'campaignId',
  budgetId: 'budgetId',
  name: 'name',
  amount: 'amount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompensationReviewPromotionBudgetScalarFieldEnum = {
  id: 'id',
  amount: 'amount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompensationReviewIncreaseRuleScalarFieldEnum = {
  id: 'id',
  campaignId: 'campaignId',
  offCycleReviewConfigurationId: 'offCycleReviewConfigurationId',
  position: 'position',
  target: 'target',
  type: 'type',
  unit: 'unit',
  hardLimit: 'hardLimit',
  amount: 'amount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompensationReviewAdminScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  campaignId: 'campaignId',
  offCycleReviewConfigurationId: 'offCycleReviewConfigurationId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompensationReviewReviewerScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  campaignId: 'campaignId',
  offCycleReviewConfigurationId: 'offCycleReviewConfigurationId',
  externalEmployeeId: 'externalEmployeeId',
  canSeeBudgets: 'canSeeBudgets',
  canSeeAnalytics: 'canSeeAnalytics',
  canReviewExceptionalBonus: 'canReviewExceptionalBonus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompensationReviewEmployeeScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  campaignId: 'campaignId',
  offCycleReviewConfigurationId: 'offCycleReviewConfigurationId',
  currencyId: 'currencyId',
  isEligible: 'isEligible',
  isEligibleForExceptionalBonus: 'isEligibleForExceptionalBonus',
  isPromoted: 'isPromoted',
  externalEmployeeId: 'externalEmployeeId',
  reviewer1Id: 'reviewer1Id',
  reviewer2Id: 'reviewer2Id',
  reviewer3Id: 'reviewer3Id',
  reviewer4Id: 'reviewer4Id',
  reviewer5Id: 'reviewer5Id',
  reviewer6Id: 'reviewer6Id',
  reviewer7Id: 'reviewer7Id',
  reviewer8Id: 'reviewer8Id',
  reviewer9Id: 'reviewer9Id',
  reviewer10Id: 'reviewer10Id',
  hasCustomReviewChain: 'hasCustomReviewChain',
  performanceRatingId: 'performanceRatingId',
  baseSalary: 'baseSalary',
  convertedBaseSalary: 'convertedBaseSalary',
  variablePay: 'variablePay',
  convertedVariablePay: 'convertedVariablePay',
  otherBonus: 'otherBonus',
  convertedOtherBonus: 'convertedOtherBonus',
  onTargetEarnings: 'onTargetEarnings',
  convertedOnTargetEarnings: 'convertedOnTargetEarnings',
  totalCash: 'totalCash',
  convertedTotalCash: 'convertedTotalCash',
  budget: 'budget',
  convertedBudget: 'convertedBudget',
  annualPerformanceBonusPayoutPercentage: 'annualPerformanceBonusPayoutPercentage',
  baseSalaryRecommendation: 'baseSalaryRecommendation',
  convertedBaseSalaryRecommendation: 'convertedBaseSalaryRecommendation',
  variablePayRecommendation: 'variablePayRecommendation',
  convertedVariablePayRecommendation: 'convertedVariablePayRecommendation',
  onTargetEarningsRecommendation: 'onTargetEarningsRecommendation',
  convertedOnTargetEarningsRecommendation: 'convertedOnTargetEarningsRecommendation',
  recommendationOrigin: 'recommendationOrigin',
  annualPerformanceBonusRecommendation: 'annualPerformanceBonusRecommendation',
  convertedAnnualPerformanceBonusRecommendation: 'convertedAnnualPerformanceBonusRecommendation',
  baseSalaryIncrease: 'baseSalaryIncrease',
  convertedBaseSalaryIncrease: 'convertedBaseSalaryIncrease',
  variablePayIncrease: 'variablePayIncrease',
  convertedVariablePayIncrease: 'convertedVariablePayIncrease',
  onTargetEarningsIncrease: 'onTargetEarningsIncrease',
  convertedOnTargetEarningsIncrease: 'convertedOnTargetEarningsIncrease',
  isIncreaseDifferentFromRecommendation: 'isIncreaseDifferentFromRecommendation',
  onTargetEarningsIncreasePercentage: 'onTargetEarningsIncreasePercentage',
  convertedNewOnTargetEarnings: 'convertedNewOnTargetEarnings',
  annualPerformanceBonus: 'annualPerformanceBonus',
  convertedAnnualPerformanceBonus: 'convertedAnnualPerformanceBonus',
  exceptionalBonus: 'exceptionalBonus',
  convertedExceptionalBonus: 'convertedExceptionalBonus',
  targetRangeAfterPromotionId: 'targetRangeAfterPromotionId',
  salaryBandMeasure: 'salaryBandMeasure',
  compaRatio: 'compaRatio',
  rangePenetration: 'rangePenetration',
  newCompaRatio: 'newCompaRatio',
  newRangePenetration: 'newRangePenetration',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CompensationReviewRecommendationScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  campaignId: 'campaignId',
  offCycleReviewConfigurationId: 'offCycleReviewConfigurationId',
  reviewerId: 'reviewerId',
  employeeId: 'employeeId',
  position: 'position',
  status: 'status',
  isFinalRecommendation: 'isFinalRecommendation',
  isListedToReviewer: 'isListedToReviewer',
  baseSalaryIncrease: 'baseSalaryIncrease',
  variablePayIncrease: 'variablePayIncrease',
  annualPerformanceBonus: 'annualPerformanceBonus',
  exceptionalBonus: 'exceptionalBonus',
  baseSalaryRecommendation: 'baseSalaryRecommendation',
  convertedBaseSalaryRecommendation: 'convertedBaseSalaryRecommendation',
  variablePayRecommendation: 'variablePayRecommendation',
  convertedVariablePayRecommendation: 'convertedVariablePayRecommendation',
  onTargetEarningsRecommendation: 'onTargetEarningsRecommendation',
  convertedOnTargetEarningsRecommendation: 'convertedOnTargetEarningsRecommendation',
  convertedOnTargetEarningsIncrease: 'convertedOnTargetEarningsIncrease',
  comment: 'comment',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  submittedAt: 'submittedAt'
};

exports.Prisma.OffCycleReviewConfigurationScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  finalReviewerId: 'finalReviewerId',
  maxReviewersCount: 'maxReviewersCount',
  allowReviewersRecommendationOverride: 'allowReviewersRecommendationOverride',
  reviewerGuidelines: 'reviewerGuidelines',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.OffCycleReviewRequestScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  configurationId: 'configurationId',
  userId: 'userId',
  declinedById: 'declinedById',
  approvedById: 'approvedById',
  externalEmployeeId: 'externalEmployeeId',
  employeeId: 'employeeId',
  status: 'status',
  reason: 'reason',
  targetRangeAfterPromotionId: 'targetRangeAfterPromotionId',
  effectiveDate: 'effectiveDate',
  comment: 'comment',
  declineComment: 'declineComment',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  declinedAt: 'declinedAt',
  approvedAt: 'approvedAt',
  completedAt: 'completedAt'
};

exports.Prisma.RemappingRequestScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  externalJobId: 'externalJobId',
  previousJobId: 'previousJobId',
  newJobId: 'newJobId',
  updatedById: 'updatedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status'
};

exports.Prisma.SubscriptionScalarFieldEnum = {
  id: 'id',
  companyId: 'companyId',
  authorId: 'authorId',
  comment: 'comment',
  startsAt: 'startsAt',
  endsAt: 'endsAt',
  product: 'product',
  type: 'type'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.FeatureFlagScope = exports.$Enums.FeatureFlagScope = {
  DISABLED: 'DISABLED',
  ADMINS_FROM_SELECTED_COMPANIES: 'ADMINS_FROM_SELECTED_COMPANIES',
  ALL_USERS_FROM_SELECTED_COMPANIES: 'ALL_USERS_FROM_SELECTED_COMPANIES',
  PUBLIC: 'PUBLIC'
};

exports.QueueJobName = exports.$Enums.QueueJobName = {
  CREATE_SALARY_BANDS: 'CREATE_SALARY_BANDS',
  SYNC_EXTERNAL_EMPLOYEES_FOR_COMPANY: 'SYNC_EXTERNAL_EMPLOYEES_FOR_COMPANY',
  SYNC_SALARY_RANGE_EMPLOYEES: 'SYNC_SALARY_RANGE_EMPLOYEES',
  CREATE_COMPENSATION_REVIEW_CAMPAIGN_EMPLOYEES: 'CREATE_COMPENSATION_REVIEW_CAMPAIGN_EMPLOYEES',
  START_COMPENSATION_REVIEW_CAMPAIGN: 'START_COMPENSATION_REVIEW_CAMPAIGN',
  PRE_SYNC_EXTERNAL_EMPLOYEES: 'PRE_SYNC_EXTERNAL_EMPLOYEES',
  SYNC_EXTERNAL_EMPLOYEES: 'SYNC_EXTERNAL_EMPLOYEES',
  POST_SYNC_EXTERNAL_EMPLOYEES: 'POST_SYNC_EXTERNAL_EMPLOYEES',
  UPDATE_SALARY_RANGE_SETTINGS: 'UPDATE_SALARY_RANGE_SETTINGS',
  DUPLICATE_SALARY_GRID_FOR_NEW_VERSION: 'DUPLICATE_SALARY_GRID_FOR_NEW_VERSION',
  IMPORT_SPREADSHEET: 'IMPORT_SPREADSHEET',
  GENERATE_SPREADSHEET: 'GENERATE_SPREADSHEET'
};

exports.QueueJobStatus = exports.$Enums.QueueJobStatus = {
  SCHEDULED: 'SCHEDULED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  ABORTED: 'ABORTED'
};

exports.HrisSyncStatus = exports.$Enums.HrisSyncStatus = {
  CREATED: 'CREATED',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE'
};

exports.UserStatus = exports.$Enums.UserStatus = {
  INVITED: 'INVITED',
  JOINED: 'JOINED'
};

exports.UserLocale = exports.$Enums.UserLocale = {
  FR: 'FR',
  EN: 'EN'
};

exports.UserProvider = exports.$Enums.UserProvider = {
  GOOGLE: 'GOOGLE',
  MICROSOFT: 'MICROSOFT',
  EMAIL_AND_TOKEN: 'EMAIL_AND_TOKEN',
  SAML: 'SAML'
};

exports.OnboardingRole = exports.$Enums.OnboardingRole = {
  HR_PEOPLE_OPERATIONS: 'HR_PEOPLE_OPERATIONS',
  RECRUITING_TALENT_ACQUISITION: 'RECRUITING_TALENT_ACQUISITION',
  COMPENSATION_BENEFITS: 'COMPENSATION_BENEFITS',
  FINANCE_CFO: 'FINANCE_CFO',
  C_LEVEL_FOUNDER: 'C_LEVEL_FOUNDER',
  TEAM_MANAGER: 'TEAM_MANAGER',
  OTHER: 'OTHER'
};

exports.BusinessUnitsRestrictionMode = exports.$Enums.BusinessUnitsRestrictionMode = {
  NONE: 'NONE',
  CLASSIC: 'CLASSIC',
  SPECIFIED: 'SPECIFIED'
};

exports.UserRole = exports.$Enums.UserRole = {
  RECRUITER: 'RECRUITER',
  HR: 'HR',
  ADMIN: 'ADMIN',
  EMPLOYEE: 'EMPLOYEE'
};

exports.EmployeeLevel = exports.$Enums.EmployeeLevel = {
  BEGINNER: 'BEGINNER',
  JUNIOR: 'JUNIOR',
  INTERMEDIATE: 'INTERMEDIATE',
  SENIOR: 'SENIOR',
  STAFF: 'STAFF',
  PRINCIPAL: 'PRINCIPAL',
  TEAM_LEAD: 'TEAM_LEAD',
  MANAGER: 'MANAGER',
  HEAD_OF: 'HEAD_OF',
  DIRECTOR: 'DIRECTOR',
  VP: 'VP',
  C_LEVEL: 'C_LEVEL'
};

exports.SalaryBandAccessLevel = exports.$Enums.SalaryBandAccessLevel = {
  NONE: 'NONE',
  RANGE: 'RANGE',
  ENTIRE_BAND: 'ENTIRE_BAND',
  ONE_LEVEL_ABOVE: 'ONE_LEVEL_ABOVE'
};

exports.JobFamilyCategory = exports.$Enums.JobFamilyCategory = {
  SALES_AND_MARKETING: 'SALES_AND_MARKETING',
  TECH: 'TECH',
  GENERAL_AND_ADMINISTRATIVE: 'GENERAL_AND_ADMINISTRATIVE'
};

exports.JobAliasLocale = exports.$Enums.JobAliasLocale = {
  EN: 'EN',
  FR: 'FR'
};

exports.EmbeddingModel = exports.$Enums.EmbeddingModel = {
  OPENAI_TEXT_EMBEDDING_3_SMALL: 'OPENAI_TEXT_EMBEDDING_3_SMALL'
};

exports.Headcount = exports.$Enums.Headcount = {
  UP_TO_24: 'UP_TO_24',
  BETWEEN_25_AND_50: 'BETWEEN_25_AND_50',
  BETWEEN_51_AND_150: 'BETWEEN_51_AND_150',
  BETWEEN_151_AND_250: 'BETWEEN_151_AND_250',
  BETWEEN_251_AND_1000: 'BETWEEN_251_AND_1000',
  BETWEEN_1001_AND_3000: 'BETWEEN_1001_AND_3000',
  BETWEEN_3001_AND_5000: 'BETWEEN_3001_AND_5000',
  MORE_THAN_5000: 'MORE_THAN_5000'
};

exports.CompanyMarketPositioningType = exports.$Enums.CompanyMarketPositioningType = {
  ENTIRE_MARKET: 'ENTIRE_MARKET',
  SPECIFIC_INDUSTRY: 'SPECIFIC_INDUSTRY',
  SIMILAR_HEADCOUNT: 'SIMILAR_HEADCOUNT',
  SIMILAR_FUNDING_STAGE: 'SIMILAR_FUNDING_STAGE'
};

exports.FundingRound = exports.$Enums.FundingRound = {
  NOT_SHARED: 'NOT_SHARED',
  PRE_SEED: 'PRE_SEED',
  SEED: 'SEED',
  SERIES_A: 'SERIES_A',
  SERIES_B: 'SERIES_B',
  SERIES_C: 'SERIES_C',
  SERIES_D: 'SERIES_D',
  SERIES_E: 'SERIES_E',
  POST_ACQUISITION: 'POST_ACQUISITION',
  POST_IPO: 'POST_IPO',
  PUBLIC_FUNDING: 'PUBLIC_FUNDING',
  SELF_FINANCED: 'SELF_FINANCED'
};

exports.ComparisonGeographicStrategy = exports.$Enums.ComparisonGeographicStrategy = {
  EMPLOYEE_LOCATION: 'EMPLOYEE_LOCATION',
  SPECIFIC_LOCATION: 'SPECIFIC_LOCATION',
  ENTIRE_COUNTRY: 'ENTIRE_COUNTRY',
  COUNTRY_CAPITAL: 'COUNTRY_CAPITAL'
};

exports.CompanyType = exports.$Enums.CompanyType = {
  PARTICIPANT: 'PARTICIPANT',
  VENTURE_CAPITAL: 'VENTURE_CAPITAL'
};

exports.HighestAvailableLevelSource = exports.$Enums.HighestAvailableLevelSource = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL'
};

exports.UseExternalLevelSource = exports.$Enums.UseExternalLevelSource = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL'
};

exports.OnboardingStep = exports.$Enums.OnboardingStep = {
  LETS_GET_TO_KNOW_EACH_OTHER: 'LETS_GET_TO_KNOW_EACH_OTHER',
  CONNECT_YOUR_HRIS: 'CONNECT_YOUR_HRIS',
  DATA_REVIEW: 'DATA_REVIEW',
  MAP_YOUR_LEVELS: 'MAP_YOUR_LEVELS',
  MAP_YOUR_LOCATIONS: 'MAP_YOUR_LOCATIONS',
  MAP_YOUR_JOBS: 'MAP_YOUR_JOBS',
  MAP_YOUR_EMPLOYEES: 'MAP_YOUR_EMPLOYEES',
  CHECK_YOUR_DATA: 'CHECK_YOUR_DATA',
  ENJOY_FIGURES: 'ENJOY_FIGURES',
  ONBOARDING_FINISHED: 'ONBOARDING_FINISHED'
};

exports.GoogleSheetType = exports.$Enums.GoogleSheetType = {
  DATA_COLLECTION: 'DATA_COLLECTION',
  PARTIAL_DATA_COLLECTION: 'PARTIAL_DATA_COLLECTION',
  GLOBAL_DATA_COLLECTION: 'GLOBAL_DATA_COLLECTION',
  EMPLOYEES_STATS: 'EMPLOYEES_STATS',
  COMPENSATION_PLANNING: 'COMPENSATION_PLANNING',
  PERFORMANCE_RATINGS: 'PERFORMANCE_RATINGS',
  SALARY_GRID: 'SALARY_GRID',
  EXTERNAL_BENCHMARK: 'EXTERNAL_BENCHMARK',
  ADDITIONAL_FIELD: 'ADDITIONAL_FIELD',
  COMPENSATION_REVIEW_BUDGET: 'COMPENSATION_REVIEW_BUDGET',
  COMPENSATION_REVIEW_RECOMMENDATION: 'COMPENSATION_REVIEW_RECOMMENDATION',
  COMPENSATION_REVIEW_ANNUAL_PERFORMANCE_BONUS: 'COMPENSATION_REVIEW_ANNUAL_PERFORMANCE_BONUS',
  MAPPING_BASIC: 'MAPPING_BASIC',
  COMPENSATION_REVIEW_CAMPAIGN: 'COMPENSATION_REVIEW_CAMPAIGN'
};

exports.CompanyImpersonationLogAction = exports.$Enums.CompanyImpersonationLogAction = {
  ACCESS: 'ACCESS',
  CREATION: 'CREATION',
  REVOKATION: 'REVOKATION',
  APPROVE: 'APPROVE',
  DECLINE: 'DECLINE'
};

exports.CompanyTagCategory = exports.$Enums.CompanyTagCategory = {
  INDUSTRY: 'INDUSTRY',
  LABEL: 'LABEL',
  REVENUE_MODEL: 'REVENUE_MODEL',
  INTERNAL: 'INTERNAL',
  INTERNAL_BENCHMARK: 'INTERNAL_BENCHMARK'
};

exports.CompanySurveyStatus = exports.$Enums.CompanySurveyStatus = {
  LIVE: 'LIVE',
  HISTORICAL: 'HISTORICAL'
};

exports.ShareGrantPolicy = exports.$Enums.ShareGrantPolicy = {
  EVERY_EMPLOYEE: 'EVERY_EMPLOYEE',
  DEPENDING_ON_EMPLOYEE_PROFILE: 'DEPENDING_ON_EMPLOYEE_PROFILE',
  DISCRETIONARY: 'DISCRETIONARY'
};

exports.ShareSecondarySalesCondition = exports.$Enums.ShareSecondarySalesCondition = {
  AT_EACH_DEPARTURE: 'AT_EACH_DEPARTURE',
  DURING_FUNDRAISING: 'DURING_FUNDRAISING',
  AT_ANY_TIME: 'AT_ANY_TIME',
  NEVER: 'NEVER'
};

exports.ShareType = exports.$Enums.ShareType = {
  BSPCE: 'BSPCE',
  GROWTH_SHARES: 'GROWTH_SHARES',
  CSOP: 'CSOP',
  EMI: 'EMI',
  RSU: 'RSU',
  VSOP: 'VSOP',
  OTHER_STOCK_OPTIONS: 'OTHER_STOCK_OPTIONS',
  OTHER_SHARES: 'OTHER_SHARES'
};

exports.EmployeeStatsComparisonScope = exports.$Enums.EmployeeStatsComparisonScope = {
  LOCATION: 'LOCATION',
  COUNTRY: 'COUNTRY'
};

exports.EmployeeStatsStatus = exports.$Enums.EmployeeStatsStatus = {
  LIVE: 'LIVE',
  HISTORICAL: 'HISTORICAL'
};

exports.EmployeeMarketPositioning = exports.$Enums.EmployeeMarketPositioning = {
  WAY_BELOW: 'WAY_BELOW',
  BELOW: 'BELOW',
  ON_TARGET: 'ON_TARGET',
  ABOVE: 'ABOVE',
  WAY_ABOVE: 'WAY_ABOVE'
};

exports.DataQuality = exports.$Enums.DataQuality = {
  NONE: 'NONE',
  FAIR: 'FAIR',
  STRONG: 'STRONG',
  EXCELLENT: 'EXCELLENT',
  AI_ESTIMATED: 'AI_ESTIMATED'
};

exports.EmployeeStatus = exports.$Enums.EmployeeStatus = {
  LIVE: 'LIVE',
  HISTORICAL: 'HISTORICAL',
  DELETED: 'DELETED'
};

exports.EmployeeSource = exports.$Enums.EmployeeSource = {
  SPREADSHEET: 'SPREADSHEET',
  MANUAL: 'MANUAL',
  ALEXISHR: 'ALEXISHR',
  BAMBOO: 'BAMBOO',
  CHARLIEHR: 'CHARLIEHR',
  FACTORIAL: 'FACTORIAL',
  HIBOB: 'HIBOB',
  HIBOB_DEPRECATED: 'HIBOB_DEPRECATED',
  HUMAANS: 'HUMAANS',
  KOMBO_PAYFIT: 'KOMBO_PAYFIT',
  KOMBO_NMBRS: 'KOMBO_NMBRS',
  KOMBO_HIBOB: 'KOMBO_HIBOB',
  KOMBO_OFFICIENT: 'KOMBO_OFFICIENT',
  KOMBO_REMOTE: 'KOMBO_REMOTE',
  KOMBO_SAGEHR: 'KOMBO_SAGEHR',
  KOMBO_SUCCESSFACTORS: 'KOMBO_SUCCESSFACTORS',
  KOMBO_DEEL: 'KOMBO_DEEL',
  KOMBO_AFAS: 'KOMBO_AFAS',
  KOMBO_KENJO: 'KOMBO_KENJO',
  KOMBO_HEAVENHR: 'KOMBO_HEAVENHR',
  KOMBO_CEZANNEHR: 'KOMBO_CEZANNEHR',
  KOMBO_ENTRAID: 'KOMBO_ENTRAID',
  KOMBO_GOOGLEWORKSPACE: 'KOMBO_GOOGLEWORKSPACE',
  KOMBO_OKTA: 'KOMBO_OKTA',
  KOMBO_EURECIA: 'KOMBO_EURECIA',
  KOMBO_ORACLEHCM: 'KOMBO_ORACLEHCM',
  KOMBO_SESAMEHR: 'KOMBO_SESAMEHR',
  KOMBO_HRWORKS: 'KOMBO_HRWORKS',
  KOMBO_BREATHEHR: 'KOMBO_BREATHEHR',
  KOMBO_CATALYSTONE: 'KOMBO_CATALYSTONE',
  KOMBO_MIRUS: 'KOMBO_MIRUS',
  KOMBO_SAPLING: 'KOMBO_SAPLING',
  KOMBO_PLANDAY: 'KOMBO_PLANDAY',
  KOMBO_HAILEYHR: 'KOMBO_HAILEYHR',
  KOMBO_DATEV: 'KOMBO_DATEV',
  KOMBO_IRISCASCADE: 'KOMBO_IRISCASCADE',
  KOMBO_FACTORIAL: 'KOMBO_FACTORIAL',
  KOMBO_MANUAL: 'KOMBO_MANUAL',
  LUCCA: 'LUCCA',
  PERSONIO: 'PERSONIO',
  PAYSPECTIVE: 'PAYSPECTIVE',
  WORKDAY: 'WORKDAY'
};

exports.Gender = exports.$Enums.Gender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  UNDISCLOSED: 'UNDISCLOSED'
};

exports.EmployeeUpdateStrategy = exports.$Enums.EmployeeUpdateStrategy = {
  PATCH: 'PATCH',
  NEW_VERSION: 'NEW_VERSION'
};

exports.DataValidationFlagOrigin = exports.$Enums.DataValidationFlagOrigin = {
  ONBOARDING: 'ONBOARDING',
  HRIS_SYNC: 'HRIS_SYNC',
  MANUAL: 'MANUAL'
};

exports.DataValidationFlagType = exports.$Enums.DataValidationFlagType = {
  SUSPICIOUS_LEVEL: 'SUSPICIOUS_LEVEL',
  SUSPICIOUS_COMPENSATION: 'SUSPICIOUS_COMPENSATION',
  SUSPICIOUS_JOB_TITLE: 'SUSPICIOUS_JOB_TITLE',
  OTHER: 'OTHER'
};

exports.CompanyValidationFlagType = exports.$Enums.CompanyValidationFlagType = {
  MISSING_CLEVEL: 'MISSING_CLEVEL',
  MISSING_MANAGER: 'MISSING_MANAGER',
  MISSING_JUNIOR: 'MISSING_JUNIOR',
  MISSING_BONUS: 'MISSING_BONUS',
  MISSING_SURVEY: 'MISSING_SURVEY',
  MISSING_CEO: 'MISSING_CEO',
  MISSING_FOUNDERS: 'MISSING_FOUNDERS'
};

exports.ContactSource = exports.$Enums.ContactSource = {
  CONTACT_FORM: 'CONTACT_FORM',
  BENEFITS: 'BENEFITS',
  NEWSLETTER: 'NEWSLETTER'
};

exports.IntegrationSource = exports.$Enums.IntegrationSource = {
  ALEXISHR: 'ALEXISHR',
  BAMBOO: 'BAMBOO',
  CHARLIEHR: 'CHARLIEHR',
  FACTORIAL: 'FACTORIAL',
  HIBOB: 'HIBOB',
  HIBOB_DEPRECATED: 'HIBOB_DEPRECATED',
  HUMAANS: 'HUMAANS',
  LUCCA: 'LUCCA',
  KOMBO_PAYFIT: 'KOMBO_PAYFIT',
  KOMBO_NMBRS: 'KOMBO_NMBRS',
  KOMBO_HIBOB: 'KOMBO_HIBOB',
  KOMBO_OFFICIENT: 'KOMBO_OFFICIENT',
  KOMBO_REMOTE: 'KOMBO_REMOTE',
  KOMBO_SAGEHR: 'KOMBO_SAGEHR',
  KOMBO_SUCCESSFACTORS: 'KOMBO_SUCCESSFACTORS',
  KOMBO_DEEL: 'KOMBO_DEEL',
  KOMBO_AFAS: 'KOMBO_AFAS',
  KOMBO_KENJO: 'KOMBO_KENJO',
  KOMBO_HEAVENHR: 'KOMBO_HEAVENHR',
  KOMBO_CEZANNEHR: 'KOMBO_CEZANNEHR',
  KOMBO_ENTRAID: 'KOMBO_ENTRAID',
  KOMBO_GOOGLEWORKSPACE: 'KOMBO_GOOGLEWORKSPACE',
  KOMBO_OKTA: 'KOMBO_OKTA',
  KOMBO_EURECIA: 'KOMBO_EURECIA',
  KOMBO_ORACLEHCM: 'KOMBO_ORACLEHCM',
  KOMBO_SESAMEHR: 'KOMBO_SESAMEHR',
  KOMBO_HRWORKS: 'KOMBO_HRWORKS',
  KOMBO_BREATHEHR: 'KOMBO_BREATHEHR',
  KOMBO_CATALYSTONE: 'KOMBO_CATALYSTONE',
  KOMBO_MIRUS: 'KOMBO_MIRUS',
  KOMBO_SAPLING: 'KOMBO_SAPLING',
  KOMBO_PLANDAY: 'KOMBO_PLANDAY',
  KOMBO_HAILEYHR: 'KOMBO_HAILEYHR',
  KOMBO_DATEV: 'KOMBO_DATEV',
  KOMBO_IRISCASCADE: 'KOMBO_IRISCASCADE',
  KOMBO_FACTORIAL: 'KOMBO_FACTORIAL',
  KOMBO_MANUAL: 'KOMBO_MANUAL',
  PERSONIO: 'PERSONIO',
  WORKDAY: 'WORKDAY'
};

exports.CompensationFrequency = exports.$Enums.CompensationFrequency = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY'
};

exports.AdditionalFieldNature = exports.$Enums.AdditionalFieldNature = {
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  DATE: 'DATE',
  PERCENTAGE: 'PERCENTAGE'
};

exports.ExternalEmployeeSource = exports.$Enums.ExternalEmployeeSource = {
  ALEXISHR: 'ALEXISHR',
  BAMBOO: 'BAMBOO',
  CHARLIEHR: 'CHARLIEHR',
  FACTORIAL: 'FACTORIAL',
  HIBOB: 'HIBOB',
  HIBOB_DEPRECATED: 'HIBOB_DEPRECATED',
  HUMAANS: 'HUMAANS',
  LUCCA: 'LUCCA',
  MANUAL: 'MANUAL',
  KOMBO_PAYFIT: 'KOMBO_PAYFIT',
  KOMBO_NMBRS: 'KOMBO_NMBRS',
  KOMBO_HIBOB: 'KOMBO_HIBOB',
  KOMBO_OFFICIENT: 'KOMBO_OFFICIENT',
  KOMBO_REMOTE: 'KOMBO_REMOTE',
  KOMBO_SAGEHR: 'KOMBO_SAGEHR',
  KOMBO_SUCCESSFACTORS: 'KOMBO_SUCCESSFACTORS',
  KOMBO_DEEL: 'KOMBO_DEEL',
  KOMBO_AFAS: 'KOMBO_AFAS',
  KOMBO_KENJO: 'KOMBO_KENJO',
  KOMBO_HEAVENHR: 'KOMBO_HEAVENHR',
  KOMBO_CEZANNEHR: 'KOMBO_CEZANNEHR',
  KOMBO_ENTRAID: 'KOMBO_ENTRAID',
  KOMBO_GOOGLEWORKSPACE: 'KOMBO_GOOGLEWORKSPACE',
  KOMBO_OKTA: 'KOMBO_OKTA',
  KOMBO_EURECIA: 'KOMBO_EURECIA',
  KOMBO_ORACLEHCM: 'KOMBO_ORACLEHCM',
  KOMBO_SESAMEHR: 'KOMBO_SESAMEHR',
  KOMBO_HRWORKS: 'KOMBO_HRWORKS',
  KOMBO_BREATHEHR: 'KOMBO_BREATHEHR',
  KOMBO_CATALYSTONE: 'KOMBO_CATALYSTONE',
  KOMBO_MIRUS: 'KOMBO_MIRUS',
  KOMBO_SAPLING: 'KOMBO_SAPLING',
  KOMBO_PLANDAY: 'KOMBO_PLANDAY',
  KOMBO_HAILEYHR: 'KOMBO_HAILEYHR',
  KOMBO_DATEV: 'KOMBO_DATEV',
  KOMBO_IRISCASCADE: 'KOMBO_IRISCASCADE',
  KOMBO_FACTORIAL: 'KOMBO_FACTORIAL',
  KOMBO_MANUAL: 'KOMBO_MANUAL',
  PAYSPECTIVE: 'PAYSPECTIVE',
  PERSONIO: 'PERSONIO',
  SPREADSHEET: 'SPREADSHEET',
  WORKDAY: 'WORKDAY'
};

exports.ExternalEmployeeStatus = exports.$Enums.ExternalEmployeeStatus = {
  UNMAPPED: 'UNMAPPED',
  MAPPED: 'MAPPED',
  SKIPPED: 'SKIPPED',
  NEEDS_REMAPPING: 'NEEDS_REMAPPING',
  PARTIAL: 'PARTIAL'
};

exports.EmployeeMappingSkipReason = exports.$Enums.EmployeeMappingSkipReason = {
  MISSING_LOCATION: 'MISSING_LOCATION',
  MISSING_JOB: 'MISSING_JOB',
  SKIPPED_LOCATION: 'SKIPPED_LOCATION',
  SKIPPED_JOB: 'SKIPPED_JOB',
  SKIPPED_LEVEL: 'SKIPPED_LEVEL',
  NOT_AN_EMPLOYEE: 'NOT_AN_EMPLOYEE',
  NOT_PERMANENT_EMPLOYEE: 'NOT_PERMANENT_EMPLOYEE',
  UNDISCLOSED: 'UNDISCLOSED',
  OTHER: 'OTHER'
};

exports.ExternalEmployeeDriftField = exports.$Enums.ExternalEmployeeDriftField = {
  LOCATION: 'LOCATION',
  JOB: 'JOB',
  LEVEL: 'LEVEL'
};

exports.ExternalRemunerationStatus = exports.$Enums.ExternalRemunerationStatus = {
  LIVE: 'LIVE',
  HISTORICAL: 'HISTORICAL'
};

exports.ExternalRemunerationType = exports.$Enums.ExternalRemunerationType = {
  FIXED_SALARY: 'FIXED_SALARY',
  FIXED_BONUS: 'FIXED_BONUS',
  VARIABLE_BONUS: 'VARIABLE_BONUS',
  PROFIT_SHARING: 'PROFIT_SHARING',
  EQUITY: 'EQUITY',
  OTHER: 'OTHER',
  PAID_BONUS: 'PAID_BONUS'
};

exports.ExternalRemunerationSubType = exports.$Enums.ExternalRemunerationSubType = {
  PARTICIPATION: 'PARTICIPATION',
  INTERESSEMENT: 'INTERESSEMENT',
  STOCK_OPTIONS: 'STOCK_OPTIONS',
  RESTRICTED_STOCK_UNITS_RSUS: 'RESTRICTED_STOCK_UNITS_RSUS',
  PERFORMANCE_BONUS: 'PERFORMANCE_BONUS',
  SALES_COMMISSION: 'SALES_COMMISSION',
  OTHER_VARIABLE_BONUS: 'OTHER_VARIABLE_BONUS',
  ANNUAL_BONUS: 'ANNUAL_BONUS',
  HOLIDAY_BONUS: 'HOLIDAY_BONUS',
  HEALTH_INSURANCE: 'HEALTH_INSURANCE',
  PENSION_CONTRIBUTION: 'PENSION_CONTRIBUTION',
  MEAL_VOUCHERS: 'MEAL_VOUCHERS',
  PUBLIC_TRANSPORT_REIMBURSEMENT: 'PUBLIC_TRANSPORT_REIMBURSEMENT',
  KILOMETRIC_ALLOWANCE: 'KILOMETRIC_ALLOWANCE',
  TRAINING_BUDGET: 'TRAINING_BUDGET',
  HOME_OFFICE_COMPENSATION: 'HOME_OFFICE_COMPENSATION',
  CHILDCARE_SUPPORT: 'CHILDCARE_SUPPORT',
  CAR_ALLOWANCE: 'CAR_ALLOWANCE',
  HOUSING_ASSISTANCE: 'HOUSING_ASSISTANCE',
  END_OF_YEAR: 'END_OF_YEAR',
  GYM_MEMBERSHIP: 'GYM_MEMBERSHIP',
  LIFE_INSURANCE: 'LIFE_INSURANCE',
  SUSTAINABLE_MOBILITY_ALLOWANCE: 'SUSTAINABLE_MOBILITY_ALLOWANCE',
  OTHER_FIXED_BONUS: 'OTHER_FIXED_BONUS',
  WELCOME_BONUS: 'WELCOME_BONUS',
  PAID_VARIABLE_BONUS: 'PAID_VARIABLE_BONUS'
};

exports.MarketDataSearchSource = exports.$Enums.MarketDataSearchSource = {
  SHARE: 'SHARE',
  RECENT: 'RECENT'
};

exports.GlassdoorConfidence = exports.$Enums.GlassdoorConfidence = {
  LOW: 'LOW',
  HIGH: 'HIGH',
  VERY_HIGH: 'VERY_HIGH'
};

exports.SalaryReviewMode = exports.$Enums.SalaryReviewMode = {
  MARKET_DATA: 'MARKET_DATA',
  SALARY_BANDS: 'SALARY_BANDS'
};

exports.PerformanceReviewCycleScope = exports.$Enums.PerformanceReviewCycleScope = {
  COMPANY: 'COMPANY',
  COMPENSATION_REVIEW_CAMPAIGN: 'COMPENSATION_REVIEW_CAMPAIGN'
};

exports.PerformanceReviewIntegrationSource = exports.$Enums.PerformanceReviewIntegrationSource = {
  CULTURE_AMP: 'CULTURE_AMP'
};

exports.SalaryGridConfigurationChangeLabel = exports.$Enums.SalaryGridConfigurationChangeLabel = {
  CREATE_BAND: 'CREATE_BAND',
  UPDATE_BENCHMARKED_JOBS: 'UPDATE_BENCHMARKED_JOBS',
  UPDATE_BENCHMARKED_LOCATIONS: 'UPDATE_BENCHMARKED_LOCATIONS',
  UPDATE_RANGE: 'UPDATE_RANGE',
  CREATE_JOB: 'CREATE_JOB',
  DELETE_JOB: 'DELETE_JOB',
  RENAME_JOB: 'RENAME_JOB',
  CREATE_LOCATION: 'CREATE_LOCATION',
  DELETE_LOCATION: 'DELETE_LOCATION',
  RENAME_LOCATION: 'RENAME_LOCATION',
  CREATE_LEVEL: 'CREATE_LEVEL',
  DELETE_LEVEL: 'DELETE_LEVEL',
  UPDATE_LEVEL: 'UPDATE_LEVEL',
  VALIDATE_BAND: 'VALIDATE_BAND',
  CONVERT_BAND_TO_DRAFT: 'CONVERT_BAND_TO_DRAFT',
  UPDATE_BANDS_WIDTH: 'UPDATE_BANDS_WIDTH',
  DELETE_RANGE: 'DELETE_RANGE',
  RECREATE_RANGE: 'RECREATE_RANGE',
  UPDATE_MARKET_POSITIONING: 'UPDATE_MARKET_POSITIONING',
  DUPLICATE_GRID_FOR_NEW_VERSION: 'DUPLICATE_GRID_FOR_NEW_VERSION',
  UPDATE_TIERS: 'UPDATE_TIERS'
};

exports.SalaryGridConfigurationStep = exports.$Enums.SalaryGridConfigurationStep = {
  CONFIGURE_STRUCTURE: 'CONFIGURE_STRUCTURE',
  CONFIGURE_MAPPING: 'CONFIGURE_MAPPING',
  CONFIGURE_BENCHMARK: 'CONFIGURE_BENCHMARK',
  SUMMARY: 'SUMMARY',
  DONE: 'DONE'
};

exports.SalaryGridMeasure = exports.$Enums.SalaryGridMeasure = {
  ON_TARGET_EARNINGS: 'ON_TARGET_EARNINGS',
  BASE_SALARY: 'BASE_SALARY'
};

exports.SalaryGridTiersMode = exports.$Enums.SalaryGridTiersMode = {
  HALVES: 'HALVES',
  THIRDS: 'THIRDS',
  QUARTERS: 'QUARTERS'
};

exports.SalaryGridStatus = exports.$Enums.SalaryGridStatus = {
  ARCHIVED: 'ARCHIVED',
  LIVE: 'LIVE',
  DRAFT: 'DRAFT'
};

exports.SalaryBandLevelTrack = exports.$Enums.SalaryBandLevelTrack = {
  INDIVIDUAL_CONTRIBUTOR: 'INDIVIDUAL_CONTRIBUTOR',
  MANAGER: 'MANAGER'
};

exports.SalaryRangeEmployeeRangePositioning = exports.$Enums.SalaryRangeEmployeeRangePositioning = {
  BELOW_RANGE: 'BELOW_RANGE',
  BOTTOM_RANGE: 'BOTTOM_RANGE',
  BOTTOM_MID_RANGE: 'BOTTOM_MID_RANGE',
  MID_RANGE: 'MID_RANGE',
  TOP_MID_RANGE: 'TOP_MID_RANGE',
  TOP_RANGE: 'TOP_RANGE',
  ABOVE_RANGE: 'ABOVE_RANGE'
};

exports.CompensationReviewCampaignStatus = exports.$Enums.CompensationReviewCampaignStatus = {
  CONFIGURATION: 'CONFIGURATION',
  SANDBOX: 'SANDBOX',
  IN_PROGRESS: 'IN_PROGRESS',
  CLOSED: 'CLOSED'
};

exports.CompensationReviewConfigurationStep = exports.$Enums.CompensationReviewConfigurationStep = {
  CAMPAIGN_DETAILS: 'CAMPAIGN_DETAILS',
  COMPENSATION_ITEMS: 'COMPENSATION_ITEMS',
  CAMPAIGN_ADMINISTRATORS: 'CAMPAIGN_ADMINISTRATORS',
  EMPLOYEES_ELIGIBILITY: 'EMPLOYEES_ELIGIBILITY',
  DATA_CHECK: 'DATA_CHECK',
  REVIEWERS_SELECTION: 'REVIEWERS_SELECTION',
  INCREASE_RULES: 'INCREASE_RULES',
  BUDGET_DEFINITION: 'BUDGET_DEFINITION',
  RECOMMENDATIONS_DEFINITION: 'RECOMMENDATIONS_DEFINITION',
  PROMOTIONS_DEFINITION: 'PROMOTIONS_DEFINITION',
  USERS_INVITATION: 'USERS_INVITATION',
  COMMUNICATION: 'COMMUNICATION',
  CONFIRM_AND_START: 'CONFIRM_AND_START'
};

exports.CompensationReviewSalaryDisplay = exports.$Enums.CompensationReviewSalaryDisplay = {
  ON_TARGET_EARNINGS: 'ON_TARGET_EARNINGS',
  TOTAL_CASH: 'TOTAL_CASH'
};

exports.CompensationReviewBudgetingMethod = exports.$Enums.CompensationReviewBudgetingMethod = {
  QUICK_ESTIMATION: 'QUICK_ESTIMATION',
  SPREADSHEET_UPLOAD: 'SPREADSHEET_UPLOAD'
};

exports.CompensationReviewBudgetDefinitionMethod = exports.$Enums.CompensationReviewBudgetDefinitionMethod = {
  PROPORTIONAL_ALLOCATION: 'PROPORTIONAL_ALLOCATION',
  TARGETED_DISTRIBUTION: 'TARGETED_DISTRIBUTION',
  SMART_ALLOCATION: 'SMART_ALLOCATION'
};

exports.CompensationReviewBudgetAdjustmentCriteria = exports.$Enums.CompensationReviewBudgetAdjustmentCriteria = {
  MARKET_POSITIONING: 'MARKET_POSITIONING',
  SALARY_BANDS_POSITIONING: 'SALARY_BANDS_POSITIONING'
};

exports.CompensationReviewIncreaseRuleTarget = exports.$Enums.CompensationReviewIncreaseRuleTarget = {
  NON_PROMOTED_EMPLOYEES: 'NON_PROMOTED_EMPLOYEES',
  PROMOTED_EMPLOYEES: 'PROMOTED_EMPLOYEES'
};

exports.CompensationReviewIncreaseRuleType = exports.$Enums.CompensationReviewIncreaseRuleType = {
  MINIMUM_INCREASE: 'MINIMUM_INCREASE',
  MAXIMUM_INCREASE: 'MAXIMUM_INCREASE',
  PROMOTION_RECOMMENDATION: 'PROMOTION_RECOMMENDATION'
};

exports.CompensationReviewIncreaseRuleUnit = exports.$Enums.CompensationReviewIncreaseRuleUnit = {
  AMOUNT: 'AMOUNT',
  PERCENTAGE: 'PERCENTAGE',
  RANGE_PENETRATION: 'RANGE_PENETRATION',
  COMPA_RATIO: 'COMPA_RATIO'
};

exports.CompensationReviewRecommendationOrigin = exports.$Enums.CompensationReviewRecommendationOrigin = {
  MANUAL: 'MANUAL',
  MATRIX: 'MATRIX',
  RULE: 'RULE'
};

exports.CompensationReviewRecommendationStatus = exports.$Enums.CompensationReviewRecommendationStatus = {
  PENDING_FOR_REVIEW: 'PENDING_FOR_REVIEW',
  PENDING_FOR_SUBMISSION: 'PENDING_FOR_SUBMISSION',
  SUBMITTED: 'SUBMITTED',
  WAITING_FOR_ANOTHER_REVIEW: 'WAITING_FOR_ANOTHER_REVIEW',
  LOCKED: 'LOCKED'
};

exports.OffCycleReviewRequestStatus = exports.$Enums.OffCycleReviewRequestStatus = {
  PENDING: 'PENDING',
  DECLINED: 'DECLINED',
  ONGOING: 'ONGOING',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
};

exports.OffCycleReviewRequestReason = exports.$Enums.OffCycleReviewRequestReason = {
  LEVEL_CHANGE: 'LEVEL_CHANGE',
  INTERNAL_MOBILITY: 'INTERNAL_MOBILITY',
  MARKET_ADJUSTMENTS: 'MARKET_ADJUSTMENTS',
  PAY_INEQUALITIES_CORRECTION: 'PAY_INEQUALITIES_CORRECTION',
  TEAM_REORGANISATION: 'TEAM_REORGANISATION',
  EXCEPTIONAL_PERFORMANCE: 'EXCEPTIONAL_PERFORMANCE',
  OTHER: 'OTHER'
};

exports.RemappingRequestStatus = exports.$Enums.RemappingRequestStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED'
};

exports.Product = exports.$Enums.Product = {
  BENCHMARK: 'BENCHMARK',
  COMPENSATION_REVIEW: 'COMPENSATION_REVIEW',
  SALARY_BANDS: 'SALARY_BANDS'
};

exports.SubscriptionType = exports.$Enums.SubscriptionType = {
  FREE: 'FREE',
  TRIAL: 'TRIAL',
  PAID: 'PAID'
};

exports.Prisma.ModelName = {
  FeatureFlag: 'FeatureFlag',
  UserAuthenticationToken: 'UserAuthenticationToken',
  QueueJob: 'QueueJob',
  QueueJobCache: 'QueueJobCache',
  HrisSyncCampaign: 'HrisSyncCampaign',
  HrisSync: 'HrisSync',
  User: 'User',
  SuperAdminRightsLog: 'SuperAdminRightsLog',
  ExceptionalImpersonationLog: 'ExceptionalImpersonationLog',
  UserSession: 'UserSession',
  CompanyPermissions: 'CompanyPermissions',
  UserPermissions: 'UserPermissions',
  UserPermissionsPolicy: 'UserPermissionsPolicy',
  UserFlags: 'UserFlags',
  JobRequest: 'JobRequest',
  JobFamily: 'JobFamily',
  Job: 'Job',
  JobAlias: 'JobAlias',
  JobAliasEmbedding: 'JobAliasEmbedding',
  CustomJob: 'CustomJob',
  CustomJobItem: 'CustomJobItem',
  Currency: 'Currency',
  Country: 'Country',
  AdditionalMonthRule: 'AdditionalMonthRule',
  CountryStats: 'CountryStats',
  CountryAlias: 'CountryAlias',
  MarketPositioning: 'MarketPositioning',
  EmailNotifications: 'EmailNotifications',
  Company: 'Company',
  CompanyFile: 'CompanyFile',
  CompanyBenchmarkRestriction: 'CompanyBenchmarkRestriction',
  GoogleSheet: 'GoogleSheet',
  CompanySamlConfiguration: 'CompanySamlConfiguration',
  CompanyImpersonationAccess: 'CompanyImpersonationAccess',
  CompanyImpersonationLog: 'CompanyImpersonationLog',
  CompanyTargetPercentile: 'CompanyTargetPercentile',
  CompanyTag: 'CompanyTag',
  CompanySurvey: 'CompanySurvey',
  CompanyEmploymentCost: 'CompanyEmploymentCost',
  CompanyStats: 'CompanyStats',
  MarketFilters: 'MarketFilters',
  EmployeeLocation: 'EmployeeLocation',
  EmployeeLocationStats: 'EmployeeLocationStats',
  EmployeeLocationAlias: 'EmployeeLocationAlias',
  BenchmarkLevel: 'BenchmarkLevel',
  LevelFramework: 'LevelFramework',
  EmployeeStats: 'EmployeeStats',
  Employee: 'Employee',
  DatasetEmployee: 'DatasetEmployee',
  EmployeeDataValidationFlag: 'EmployeeDataValidationFlag',
  CompanyDataValidationFlag: 'CompanyDataValidationFlag',
  Image: 'Image',
  Contact: 'Contact',
  IntegrationSettings: 'IntegrationSettings',
  IntegrationLock: 'IntegrationLock',
  AdditionalField: 'AdditionalField',
  AdditionalFieldMapping: 'AdditionalFieldMapping',
  AdditionalFieldValue: 'AdditionalFieldValue',
  AnalyticsEmployee: 'AnalyticsEmployee',
  ExternalEmployee: 'ExternalEmployee',
  ExternalLocation: 'ExternalLocation',
  ExternalJob: 'ExternalJob',
  ExternalJobMappingSuggestion: 'ExternalJobMappingSuggestion',
  ExternalLevel: 'ExternalLevel',
  ExternalRemunerationItem: 'ExternalRemunerationItem',
  ExternalRemunerationNature: 'ExternalRemunerationNature',
  CustomRemunerationItem: 'CustomRemunerationItem',
  MarketDataSearch: 'MarketDataSearch',
  FiltersPreset: 'FiltersPreset',
  GlassdoorCompensationData: 'GlassdoorCompensationData',
  CompensationPlanningCampaign: 'CompensationPlanningCampaign',
  CompensationPlanningInflationSettings: 'CompensationPlanningInflationSettings',
  CompensationPlanningEmployee: 'CompensationPlanningEmployee',
  CompensationPlanningPerformanceRating: 'CompensationPlanningPerformanceRating',
  PerformanceReviewCycle: 'PerformanceReviewCycle',
  PerformanceReviewRating: 'PerformanceReviewRating',
  PerformanceReviewIntegrationSettings: 'PerformanceReviewIntegrationSettings',
  SalaryGridConfigurationChange: 'SalaryGridConfigurationChange',
  SalaryGrid: 'SalaryGrid',
  SalaryBandJob: 'SalaryBandJob',
  SalaryBandMappedJob: 'SalaryBandMappedJob',
  SalaryBandLevel: 'SalaryBandLevel',
  SalaryBandMappedLevel: 'SalaryBandMappedLevel',
  SalaryBandBenchmarkedLevel: 'SalaryBandBenchmarkedLevel',
  SalaryBandLocation: 'SalaryBandLocation',
  SalaryBandMappedLocation: 'SalaryBandMappedLocation',
  SalaryBand: 'SalaryBand',
  SalaryBandBenchmarkedJob: 'SalaryBandBenchmarkedJob',
  SalaryBandBenchmarkedLocation: 'SalaryBandBenchmarkedLocation',
  SalaryBandMarketPositioning: 'SalaryBandMarketPositioning',
  SalaryRange: 'SalaryRange',
  SalaryRangeEmployee: 'SalaryRangeEmployee',
  SalaryBandShare: 'SalaryBandShare',
  ExternalBenchmark: 'ExternalBenchmark',
  ExternalBenchmarkLevel: 'ExternalBenchmarkLevel',
  ExternalBenchmarkGroup: 'ExternalBenchmarkGroup',
  ExternalBenchmarkEntry: 'ExternalBenchmarkEntry',
  CompensationReviewCampaign: 'CompensationReviewCampaign',
  CompensationReviewCurrency: 'CompensationReviewCurrency',
  CompensationReviewBudget: 'CompensationReviewBudget',
  CompensationReviewSubBudget: 'CompensationReviewSubBudget',
  CompensationReviewPromotionBudget: 'CompensationReviewPromotionBudget',
  CompensationReviewIncreaseRule: 'CompensationReviewIncreaseRule',
  CompensationReviewAdmin: 'CompensationReviewAdmin',
  CompensationReviewReviewer: 'CompensationReviewReviewer',
  CompensationReviewEmployee: 'CompensationReviewEmployee',
  CompensationReviewRecommendation: 'CompensationReviewRecommendation',
  OffCycleReviewConfiguration: 'OffCycleReviewConfiguration',
  OffCycleReviewRequest: 'OffCycleReviewRequest',
  RemappingRequest: 'RemappingRequest',
  Subscription: 'Subscription'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
